"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base = {
    white: '#ffffff',
    black: '#000000',
    transparent: '#00000000',
};
const gray = {
    0: '#ffffff',
    50: '#fafaf9',
    150: '#f7f7f7',
    200: '#f6f7f8',
    250: '#f5f5f5',
    300: '#f4f4f4',
    375: '#ebebeb',
    400: '#ebeff2',
    450: '#ecebea',
    500: '#dfdfdf',
    550: '#c9c7c5',
    725: '#a1afb5',
    850: '#969492',
    950: '#81929b',
    975: '#777777',
    1025: '#706e6b',
    1050: '#687982',
    1200: '#3e3e3c',
    1250: '#333333',
    1300: '#1F1F1F',
    1350: '#121212',
    1400: '#22262a',
};
const blue = {
    50: '#eef5fd',
    80: '#f5faff',
    100: '#e5f0fc',
    150: '#ebf2f7',
    200: '#d5e6f1',
    221: '#f3f8fc',
    400: '#bfd9fc',
    500: '#9bcbeb',
    650: '#74b8ff',
    700: '#5cb3ea',
    750: '#4a90e2',
    800: '#3a72b5',
    850: '#2989ff',
    900: '#1f93db',
    925: '#1f6bb1',
    930: '#1f74ba',
    950: '#1E69AC',
    990: '#1a4985',
    1025: '#004eae',
    1030: '#3653d5',
    1040: '#2d46b5',
    1075: '#1f599e',
    1100: '#00234D',
};
const green = {
    50: '#e8f5ea',
    75: '#e5f7e5',
    100: '#c3e7c8',
    200: '#add7ad',
    400: '#67de6f',
    500: '#5ac402',
    600: '#34ab3c',
    700: '#2bab83',
    750: '#118819',
    800: '#04a769',
    850: '#00b045',
    900: '#008e38',
    950: '#116611',
    960: '#1166114D',
};
const yellow = {
    25: '#fff486',
    50: '#fffad7',
    100: '#fff9e9',
    150: '#fff3e2',
    175: '#fcf3e0',
    200: '#ffe4a0',
    300: '#f5dbb5',
    350: '#EAC563',
    400: '#f5a623',
    500: '#f29d50',
    625: '#ffd444',
    650: '#eaa111',
    700: '#c67d00',
    750: '#ffee00',
    900: '#422006',
};
const red = {
    50: '#fcebee',
    100: '#f4d2d0',
    200: '#ef7d5b',
    250: '#ff6e6e',
    400: '#da6561',
    500: '#dc3b3b',
    600: '#eb1515',
    700: '#d70015',
    750: '#c45353',
    800: '#b91818',
    900: '#330000',
};
const orange = {
    500: '#ff8000',
    600: '#f1635f',
};
const pink = {
    100: '#c7939b',
    200: '#ff3e7a',
};
const purple = {
    100: '#9b91c5',
    300: '#7d6fc4',
};
const teal = {
    100: '#79d5e0',
    400: '#088391',
    500: '#08a2b5',
};
const alpha = {
    black: {
        1: '#00000003',
        3: '#00000008',
        7: '#00000012',
        10: '#0000001a',
        12: '#0000001f',
        20: '#00000033',
        30: '#0000004d',
        40: '#00000066',
        50: '#00000080',
        60: '#00000099',
    },
    white: {
        1: '#ffffff03',
        3: '#ffffff08',
        7: '#ffffff12',
        10: '#ffffff1a',
        12: '#ffffff1f',
        20: '#ffffff33',
        30: '#ffffff4d',
        40: '#ffffff66',
        50: '#ffffff80',
        60: '#ffffff99',
    },
};
const blueAlpha = {
    20: '#0064ab08',
};
const overlay = {
    white: {
        10: '#FFFFFF1A',
        20: '#FFFFFF33',
        30: '#ffffff4d',
        50: '#FFFFFF80',
        70: '#ffffffb3',
    },
    black: {
        10: '#0000001A',
        12: '#0000001f',
        20: '#00000033',
        30: '#0000004d',
        50: '#00000080',
        70: '#000000b3',
    },
};
const blueberry = {
    50: '#b7c4f0',
    70: '#89a0e6',
    100: '#496ed8',
};
const clementine = {
    100: '#f2866d',
};
const gold = {
    30: '#f9efd4',
    100: '#eac563',
};
const orchid = {
    100: '#9882c4',
};
const jadeite = {
    100: '#62b59e',
};
exports.default = {
    base,
    gray,
    blue,
    green,
    yellow,
    red,
    orange,
    pink,
    purple,
    teal,
    alpha,
    blueAlpha,
    overlay,
    blueberry,
    clementine,
    gold,
    orchid,
    jadeite,
};
